import { Component } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';

import { take } from 'rxjs';

import { CONFIG } from '@cpd-app/configuration';
import { AuthFacade } from '@cpd-app/state/auth';
import { GoalFacade } from '@cpd-app/state/goal';
import { TrackerFacade } from '@cpd-app/state/tracker';
import { UserProfileFacade } from '@cpd-app/state/user-profile';
import { UserProfileResponse } from '@cpd-app/state/user-profile/user-profile.response';

@Component({
  templateUrl: './save-session-dialog.component.html',
  styleUrls: ['./save-session-dialog.component.scss']
})
export class SaveSessionDialogComponent {
  public formGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email])
  });
  public title = CONFIG.STATIC_CONTENT.RETURN_LINK.TITLE;
  public introMessage = CONFIG.STATIC_CONTENT.RETURN_LINK.INTRO;
  public sentTitle = CONFIG.STATIC_CONTENT.RETURN_LINK.TITLE_SENT;
  public sentMessage = CONFIG.STATIC_CONTENT.RETURN_LINK.MESSAGE;
  public isEmailSent = false;

  public isAirForce$ = this.userProfileFacade.isAirForce$;
  public isArmy$ = this.userProfileFacade.isArmy$;
  public returnLink$ = this.goalFacade.returnLink$;
  public isSpaceForce$ = this.userProfileFacade.isSpaceForce$;
  public tooltipMsg: string =
    CONFIG.STATIC_CONTENT.GOALS_REPORT.DOWNLOAD.MESSAGE;
  public tooltipMsgForAirforce: string =
    CONFIG.STATIC_CONTENT.GOALS_REPORT.DOWNLOAD.MESSAGE_FOR_AIRFORCE;

  constructor(
    private authFacade: AuthFacade,
    private goalFacade: GoalFacade,
    private trackerFacade: TrackerFacade,
    private userProfileFacade: UserProfileFacade,
    private userProfileResponse: UserProfileResponse
  ) {}

  public onSubmit(): void {
    if (this.formGroup.valid) {
      this.authFacade.createReturnSession(this.formGroup.controls.email.value);
      this.trackerFacade.reportShared();

      this.userProfileResponse.userProfileHasReturnLink$
        .pipe(take(1))
        .subscribe(() => (this.isEmailSent = true));
    }
  }
}
